/*
 * @Author: xiaoyufeng
 * @Date: 2021-04-13 10:30:47
 * @LastEditors: xiaoyufeng
 * @LastEditTime: 2021-04-19 10:16:43
 */
// 兼容Qt浏览器全屏
import { Message } from 'element-ui'
const $_Qt_fullScreen_fix = function (params) {
  const isQTwindow = /zyzxteacher/.test(navigator.userAgent.toLowerCase()) || /qwebengineview/.test(navigator.userAgent.toLowerCase())
  if (isQTwindow) {
    console.log(params)
    let exitIconDom = document.createElement('div')
    exitIconDom.classList.add('exitIcon')
    exitIconDom.innerHTML = `<svg t="1618296944200" class="icon" viewBox="0 0 1032 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9291" width="18" height="18"><path d="M238.206348 284.981132h-190.665343c-9.660377 0-18.303873 4.067527-23.896723 10.168818-10.677259 10.677259-15.253227 28.981132-2.542205 44.23436 7.118173 8.643496 18.303873 13.727905 29.998014 13.727904h233.882821c37.624628 0 68.131082-30.506455 68.131082-68.131082v-237.441907c0-9.660377-4.067527-18.303873-10.168818-23.896723-10.677259-10.677259-28.981132-15.253227-44.23436-2.542204-8.643496 7.118173-13.727905 18.303873-13.727904 29.998014v187.106256l-228.289971-228.28997c-12.711023-13.219464-33.5571-13.219464-46.776564 0-12.711023 12.711023-12.711023 34.065541 0 46.776564l228.289971 228.28997zM284.982912 664.278054h-237.441907c-9.660377 0-18.303873 4.067527-23.896723 10.168818-10.677259 10.677259-15.253227 28.981132-2.542205 44.234359 7.118173 8.643496 18.303873 13.727905 29.998014 13.727905h187.106257l-228.289971 228.28997c-13.219464 12.711023-13.219464 33.5571 0 46.776564 12.711023 12.711023 34.065541 12.711023 46.776564 0l228.289971-228.28997v190.665343c0 9.660377 4.067527 18.303873 10.168818 23.896723 10.677259 10.677259 28.981132 15.253227 44.234359 2.542204 8.643496-7.118173 13.727905-18.303873 13.727905-29.998014v-233.88282c0.508441-37.624628-29.998014-68.131082-68.131082-68.131082zM1016.120945 967.308838l-228.28997-228.28997h190.665343c9.660377 0 18.303873-4.067527 23.896723-10.168818 10.677259-10.677259 15.253227-28.981132 2.542204-44.23436-7.118173-8.643496-18.303873-13.727905-29.998014-13.727904h-233.88282c-37.624628 0-68.131082 30.506455-68.131082 68.131082V976.460775c0 9.660377 4.067527 18.303873 10.168818 23.896723 10.677259 10.677259 28.981132 15.253227 44.234359 2.542204 8.643496-7.118173 13.727905-18.303873 13.727905-29.998014v-187.106256l228.28997 228.28997c12.711023 13.219464 33.5571 13.219464 46.776564 0 12.711023-12.711023 12.711023-34.065541 0-46.776564zM733.936238 353.112214h237.441907c9.660377 0 18.303873-4.067527 23.896723-10.168818 10.677259-10.677259 15.253227-28.981132 2.542204-44.234359-7.118173-8.643496-18.303873-13.727905-29.998013-13.727905h-187.106257l228.289971-228.28997c13.219464-12.711023 13.219464-33.5571 0-46.776564-12.711023-12.711023-34.065541-12.711023-46.776564 0l-228.289971 228.28997v-190.665343c0-9.660377-4.067527-18.303873-10.168818-23.896723-10.677259-10.677259-28.981132-15.253227-44.234359-2.542204-8.643496 7.118173-13.727905 18.303873-13.727905 29.998014v233.88282c0.508441 37.624628 31.014896 68.131082 68.131082 68.131082z" p-id="9292" fill="#ffffff"></path></svg>`
    exitIconDom.style = `
        position: absolute;
        right: 10px;
        top: 10px;
        width: 24px;
        height: 24px;
        background-color: #c3c3c3;
        padding: 3px;
        border-radius: 5px;
        cursor: pointer;`
    const _runCallback = function (name) {
      if (params[name] && typeof params[name] === 'function') {
        params[name]();
      }
    }
    // 退出全屏
    const _exit = function () {
      params.element.classList.remove('qt_full_screen_element')
      document.body.style.overflow = 'unset'
      if(params.exit){
        exitIconDom = params.element.querySelector('.exitIcon')
      }
      try {
        params.element.removeChild(exitIconDom)
      } catch (error) {

      }
      if (params.exitElement) {
        params.exitElement.removeEventListener('click', _exit)
      }
      _removeListener()
      _runCallback('onExit')
    }
    // 进入全屏
    const _enter = function () {
      params.element.classList.add('qt_full_screen_element');
      document.body.style.overflow = 'hidden'
      if (params.showExitbutton!==false) {
        params.element.appendChild(exitIconDom)
        Message('点击右侧按钮可退出全屏');
      }
      if (params.exitElement) {
        params.exitElement.addEventListener('click', _exit)
      }
      exitIconDom.addEventListener('click', _exit)
      _addListener()
      _runCallback('onEnter')
    }
    // 键盘Esc事件
    const _listenerFunc = function (e) {
      console.log(e)
      if (e.keyCode === 27) {
        _exit()
      }
    }
    const _addListener = function () {
      document.addEventListener('keyup', _listenerFunc)
    }
    const _removeListener = function () {
      document.removeEventListener('keyup', _listenerFunc)
    }
    if (params.exit) {
      _exit(params)
    } else {
      _enter(params)
    }
  } else {
    console.warn('[CODE] 非卓越在线，未使用全屏兼容方法')
  }
}
export { $_Qt_fullScreen_fix }
